import { Injectable } from '@angular/core';
import { FileSaverService } from 'ngx-filesaver';

@Injectable()
export class DownloadFileService {
  constructor(private readonly fileSaverService: FileSaverService) {}
  public save(blob: Blob, fileName?: string): void {
    this.fileSaverService.save(blob, fileName);
  }
}
